// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__hi5LS","rotation":"Loader_rotation__nIfLx"};